module.exports = __webpack_public_path__ + "img/CX.a4343636.svg";